import { Transition } from "../../../core/flows/Transition";
import { ServiceRequestClaimContext } from "../Context/ServiceRequestClaimContext";

export class ServiceRequestClaimTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<ServiceRequestClaimContext>("serviceRequestClaimContext", this.entryStep)!

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}